var utils = require("lib/utils");

var LoadService = {
  load: function(files){
    var deferred = $.Deferred();
    var xhrs = [];
    var content = {};

    _.each(_.keys(files), function(f){
      var url = utils.coursePath(files[f]);
      var xhr = $.getJSON(url);
      xhr.done(function(data){
        content[f] = data;
      });
      xhr.fail(function(){
        deferred.reject();
      });
      xhrs.push(xhr);
    });

    $.when.apply($, xhrs).done(function(){
      deferred.resolve(content);
    });

    return deferred.promise();
  }
};

module.exports = LoadService;
